import { Car } from "lucide-react";
import { where } from "firebase/firestore";
import { useEffect, useState } from "react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { useCollection } from "functions/hooks/useCollection";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusVehicle({ device, deviceId }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const [vehicle, setVehicle] = useState<any>(null);
  const vehiclesCollection = useCollection<any>('vehicles');
  const vehicleBatteryConnected = device?.BatteryStatusLog?.vehicleBatteryConnected;
  
  useEffect(() => {
    (async () => {
      const response = await vehiclesCollection.queryOne([where('deviceId', '==', deviceId)]);   
      if (response?.data) {
        setVehicle(response.data);
      }
    })();
  }, [deviceId]);

  return (
    <ViewMgtDevicePanel title="Vehicle" icon={<Car size={16} />}>
      <div className="grid grid-cols-1 gap-0">

        <ViewMgtDeviceStatusValue 
          label="Battery"
          timestamp={device?.BatteryStatusLog?.logTimestamp}
          value={vehicleBatteryConnected ? "Connected" : "Disconnected"}
          color={vehicleBatteryConnected ? " text-green-500" : "text-red-500"}
          />

        <ViewMgtDeviceStatusValue 
          label="Voltage"
          color="text-slate-500"
          timestamp={device?.BatteryStatusLog?.logTimestamp}
          value={`${device?.BatteryStatusLog?.vehicleBatteryVoltageMilli} millivolts`}
          />

       <ViewMgtDeviceStatusValue
          label="Registration Number"
          value={vehicle?.details?.registrationNumber}
          color={"text-state-500"}
          timestamp={"-"}
          />

        <ViewMgtDeviceStatusValue
          label="Make"
          value={vehicle?.details?.make}
          color={"text-state-500"}
          timestamp={"-"}
          />

        <ViewMgtDeviceStatusValue
          label="Model"
          value={vehicle?.details?.model}
          color={"text-state-500"}
          timestamp={"-"}
          />

      </div>
    </ViewMgtDevicePanel>
  );
}
